import { useState, useEffect } from 'react';
import { IFieldInfo, ISigner } from '../GenericForms/formTypes';
import Icon, { IconType } from '../Icon/Icon';

interface IPdfLink {
  position: number[];
  url: string;
  scale: number;
}

const PdfLink = (props: IPdfLink) => {
  const [scale, setScale] = useState<number>(props.scale);
  const left = props.position[0] * scale;
  const width = (props.position[2] - props.position[0]) * scale + 2;
  const height = (props.position[3] - props.position[1]) * scale - 2;
  const bottom = props.position[3] * scale - height;

  const onClick = () => {
    //open new tab with the link
    if (props.url) {
      window.open(props.url, '_blank');
    }
  };

  return (
    <>
      <div
        className={`zpdf-link`}
        style={{
          left: left,
          bottom: bottom,
          width: width,
          minHeight: height,
        }}
        title={'Click to open link'}
        onClick={onClick}></div>
    </>
  );
};

export default PdfLink;
